module.exports = "<div class=\"post-text-getter\">\r\n\r\n\r\n  <div class=\"Title\">\r\n    Enter new post text\r\n  </div>\r\n\r\n  <mat-form-field>\r\n    <input matInput type=\"text\" maxlength=\"20\" [(ngModel)]=\"currentInfo.text\">\r\n  </mat-form-field>\r\n\r\n\r\n  <button mat-raised-button color=\"primary\" class=\"applyBtn\" (click)=\"apply()\">Apply</button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/services/proTools/ng-components/post-text-getter/post-text-getter.component.html
// module id = ./src/app/services/proTools/ng-components/post-text-getter/post-text-getter.component.html
// module chunks = main